/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function HandSoap(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M184,96.80469V88a32.03667,32.03667,0,0,0-32-32H136V32h32a8.00917,8.00917,0,0,1,8,8,8,8,0,0,0,16,0,24.0275,24.0275,0,0,0-24-24H104a8,8,0,0,0,0,16h16V56H104A32.03667,32.03667,0,0,0,72,88v8.80469A40.06815,40.06815,0,0,0,40,136v80a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V136A40.06815,40.06815,0,0,0,184,96.80469ZM104,72h48a16.01833,16.01833,0,0,1,16,16v8H88V88A16.01833,16.01833,0,0,1,104,72Z" />
    </Svg>
  );
}

export default HandSoap;
